class ContentFromEditor {
    constructor(context, settings, $) {
        // Environment variables
        this.context = context;
        this.settings = settings;
        this.$ = $;

        this.$contentFromEditor = this.$('.js-content-from-editor', this.context).once();
        this.$tables = this.$('.js-content-from-editor table', this.context).once()

        this.wrapTable();
    }

    wrapTable() {
        this.$tables.each((index, element) => {
            const $el = this.$(element);

            if ($el.width() > this.$contentFromEditor.width()) {
                $el.wrap('<div class="wide-table"><div class="wide-table-inner"></div></div>');
            }
        });
    }
}

export default ContentFromEditor;
